import { getCookies } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedLoginRoute: React.FC<{
    element: React.ReactNode;
}> = ({ element }) => {
    const location = useLocation();
    const isAuthenticated = Boolean(
        getCookies(`${import.meta.env.VITE_BUSINESS}token`),
    );
    const dashboardPath = RoutesLink.dashboard;

    const isOauth = location.pathname.includes('sso-login');

    return (!isAuthenticated || isOauth) ? element : <Navigate to={{ pathname: dashboardPath, search: location.search }} replace />;
};
export default ProtectedLoginRoute;
